'use client';

import { updateEnrollment } from '@/app/[domain]/[locale]/actions/enrollment-action';
import { Button } from '@/ui';
import { useRouter } from '@/i18n/routing';
import { Enrollment } from '@/drizzle/models';
import { CourseViewModel } from '@hidayahlab/academy-suite-corelib';

type MyCourseCardActionProps = {
  label: string;
  enrollmentStatus: Enrollment['status'];
  enrollmentId: number;
  courseId: number;
  format: CourseViewModel['format'];
};

export const MyCourseCardAction = ({
  enrollmentStatus,
  label,
  enrollmentId,
  courseId,
  format,
}: MyCourseCardActionProps) => {
  const router = useRouter();

  const url =
    format === 'LIVE'
      ? `/my-classes/live/${courseId}`
      : `/my-classes/recorded/${courseId}`;

  const handleEnrollmentUpdate = async () => {
    enrollmentStatus === 'NOT_STARTED' &&
      (await updateEnrollment(
        {
          status: 'IN_PROGRESS',
        },
        enrollmentId,
      ));

    router.push(url);
  };

  return (
    <Button onClick={handleEnrollmentUpdate} className="text-sm">
      {label}
    </Button>
  );
};
